module.exports = __webpack_public_path__ + "img/c05_unittechspearmanchampion_Normal_ua.8b84436a.webp";